import styled, { css } from 'styled-components';

export const ContentWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 24px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      gap: 16px;
    }
  `}
`;

export const SectionContainer = styled.div`
  ${({ theme, $padding }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 16px;
    padding: ${$padding || '24px'};
    flex: 1;
    min-width: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 16px;
    }
  `}
`;

export const StatsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 32px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      align-items: stretch;
      gap: 24px;
    }
  `}
`;

export const StatItem = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 12px;
    min-width: 314px;
    padding: 16px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      min-width: auto;
      width: 100%;
      padding: 12px 8px;
    }
  `}
`;

export const StatIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5a5f66;
  flex-shrink: 0;
`;

export const StatContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StatTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const StatDivider = styled.div`
  ${({ theme }) => css`
    width: 1px;
    height: 100px;
    background-color: #dfe2eb;
    align-self: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      display: none;
    }
  `}
`;

export const StatTitle = styled.span`
  ${({ theme }) => css`
    color: #2c3137;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const StatSubtitle = styled.span`
  ${({ theme }) => css`
    color: #5a5f66;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const StatValueRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 8px;
`;

export const StatValue = styled.span`
  ${({ theme }) => css`
    color: #2c3137;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xl};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 1;
  `}
`;

export const StatPercentage = styled.span`
  ${({ theme, isPositive }) => css`
    color: ${isPositive ? '#31a546' : '#dc3545'};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    display: flex;
    align-items: center;
    gap: 2px;
  `}
`;

export const StatsButtonWrapper = styled.div`
  ${({ theme }) => css`
    margin-left: auto;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin-left: 0;
      width: 100%;

      button {
        width: 100%;
      }
    }
  `}
`;

export const InsightBanner = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    padding: 16px;
    border: 1px solid #d2e4ff;
    border-radius: 8px;
    background-color: ${theme.v2.colors.neutral.highPure};
    margin-top: 32px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin-top: 24px;
      padding: 12px;
      gap: 8px;
    }
  `}
`;

export const InsightIcon = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${theme.v2.colors.brand.primaryMedium};
    flex-shrink: 0;
  `}
`;

export const InsightText = styled.span`
  ${({ theme }) => css`
    color: #2c3137;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const HighlightText = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.feedback.activeMedium};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.bold};
  `}
`;

export const MainContentContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: 24px;
    flex: 1;

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      flex-direction: column;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      gap: 16px;
    }
  `}
`;

export const RecentCampaignsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 32px;
    flex: 1;
    min-width: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      gap: 24px;
    }
  `}
`;

export const ViewAllButtonWrapper = styled.div`
  ${({ theme }) => css`
    align-self: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      align-self: stretch;
    }
  `}
`;

export const RecentCampaignsHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const RecentCampaignsTitle = styled.h3`
  ${({ theme }) => css`
    color: #2c3137;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.title};
    margin: 0;
  `}
`;

export const CampaignsList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CampaignItem = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 16px;
    padding: 16px;
    border: 1px solid transparent;
    border-radius: 8px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 12px 8px;
      gap: 12px;
    }
  `}
`;

export const CampaignDivider = styled.div`
  ${({ theme }) => css`
    height: 1px;
    background-color: ${theme.v2.colors.neutral.highMedium};
    margin: 16px 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 12px 0;
    }
  `}
`;

export const CampaignThumbnail = styled.img`
  ${({ theme }) => css`
    width: 103px;
    height: 77px;
    border-radius: 8px;
    object-fit: cover;
    flex-shrink: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 80px;
      height: 60px;
    }
  `}
`;

export const CampaignInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
  min-width: 0;
`;

export const CampaignTitle = styled.span`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 4px;
    color: #5a5f66;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 100%;
  `}
`;

export const CampaignDescription = styled.span`
  ${({ theme }) => css`
    color: #2c3137;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 150%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    align-self: stretch;
  `}
`;

export const CampaignStatus = styled.span`
  ${({ theme, status }) => {
    const statusStyles = {
      pending: css`
        background-color: ${theme.v2.colors.feedback.pendingUltraLight};
        color: #5a1c00;
        border: none;
      `,
      success: css`
        background-color: #ebffe5;
        color: #005318;
        border: none;
      `,
      draft: css`
        background-color: transparent;
        color: #73777f;
        border: 1px solid #73777f;
      `,
      archived: css`
        background-color: #e5e7f2;
        color: #3e4552;
        border: none;
      `,
      error: css`
        background-color: #ffe5e5;
        color: #8b0000;
        border: none;
      `,
      paused: css`
        background-color: transparent;
        color: #73777f;
        border: 1px solid #73777f;
      `,
    };

    return css`
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: ${theme.v2.font.family.primary};
      font-size: ${theme.v2.font.sizes.xs};
      font-weight: ${theme.v2.font.weights.medium};
      line-height: 150%;
      padding: 0 8px;
      height: 24px;
      border-radius: 4px;
      white-space: nowrap;
      ${statusStyles[status] || statusStyles.draft}
    `;
  }}
`;

export const SideCardsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 381px;
    flex-shrink: 0;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 16px;
    padding: 24px;

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      width: 100%;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 16px;
    }
  `}
`;

export const ActionCardIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #2c3137;
`;

export const ActionCardTitle = styled.span`
  ${({ theme }) => css`
    color: #2c3137;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.title};
    transition: color 0.3s ease;
  `}
`;

export const ActionCardDescription = styled.span`
  ${({ theme }) => css`
    color: #5a5f66;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const ActionCardInterestBox = styled.div`
    display: none;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
    background-color: #F5F9FF;
    border-radius: 8px;
    margin-top: 8px;
`;

export const ActionCardInterestTitle = styled.span`
  ${({ theme }) => css`
    color: #3094EF;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.title};

    &::after {
      content: ' →';
    }
  `}
`;

export const ActionCardInterestMessage = styled.span`
  ${({ theme }) => css`
    color: #5a5f66;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const ActionCard = styled.div`
  ${({ $disabled }) => css`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    cursor: pointer;
    border: 1px solid transparent;
    border-radius: 8px;
    transition: all 0.3s ease;

    ${$disabled && css`
      opacity: 0.6;
      pointer-events: none;
      cursor: not-allowed;
    `}

    &:hover {
      border-color: #3094EF;
      box-shadow: 0px 0px 8px 0px rgba(210, 228, 255, 1);
    }

    ${$disabled && css`
      &:hover {
        border-color: transparent;
        box-shadow: none;
      }
    `}

    ${!$disabled && css`
      &:hover ${ActionCardTitle} {
        color: #3094EF;
      }

      &:hover ${ActionCardTitle}::after {
        content: ' →';
      }
    `}

    ${css`
      &:hover ${ActionCardInterestBox} {
        display: flex;
      }
    `}
  `}
`;

export const CardDivider = styled.div`
  ${({ theme }) => css`
    height: 1px;
    background-color: ${theme.v2.colors.neutral.highMedium};
    margin: 32px 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 24px 0;
    }
  `}
`;

export const ComingSoonBadge = styled.span`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.brand.primaryLowLight};
    color: ${theme.v2.colors.brand.primaryMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    padding: 4px 8px;
    border-radius: 4px;
    white-space: nowrap;
    width: fit-content;
    margin-bottom: 12px;
  `}
`;

export const ViewAllLink = styled.button`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  `}
`;

export const EmptyCampaignsMessage = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 40px;
    color: #5a5f66;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    text-align: center;
  `}
`;

export const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  & > div {
    padding: 0px;
    border: 0px;
    & > div {
      padding: 0px;
    }
  }
`;
